export default __webpack_public_path__ + "static/media/list_view_icon_inactive.15f2abd0.svg";